import { Component } from '@angular/core';

@Component({
    templateUrl: './explore-schedule-on-stop-additional-info-page.component.html'
})
export class ExploreScheduleOnStopAdditionalInfoPageComponent {}
